import { FinalCTA } from "./FinalCTA";
import Hero from "./Hero";
import { HowItWorks } from "./HowItWorks";
import { TrustSectionBlock } from "./TrustSection";
import { WhatYouGet } from "./WhatYouGet";
import { PainAndReality } from "./WhySection";

export default function CareerClarityTestPage() {
  return (
    <main className="min-h-screen text-white bg-[linear-gradient(180deg,#06101d_0%,#040814_100%)]">
      <Hero />
      <PainAndReality />
      <HowItWorks />

      <WhatYouGet />
      <TrustSectionBlock />
      <FinalCTA />
    </main>
  );
}
